import { PrimaryCTA } from "./PrimaryCTA";

interface EnterpriseCardProps {
  onBookCall: (e: React.MouseEvent) => void;
}

export function EnterpriseCard({ onBookCall }: EnterpriseCardProps) {
  return (
    <div className="bg-card rounded-2xl border p-8 shadow-sm transition-shadow hover:shadow-md md:p-12">
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="text-center md:text-left">
          <h3 className="mb-2 font-semibold text-gray-900">Enterprise</h3>
          <p className="text-muted-foreground max-w-2xl">
            Custom solutions for large teams with advanced security, compliance,
            and dedicated support. Volume pricing available.
          </p>
        </div>
        <PrimaryCTA
          onClick={onBookCall}
          className="shrink-0"
          showArrow={true}
          data-event="Checkout Started"
          data-plan="enterprise"
        >
          Book a call
        </PrimaryCTA>
      </div>
    </div>
  );
}
